// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var MM_parser = require("../mm-utils/MM_parser.bs.js");
var FileLoader = require("../utils/FileLoader.bs.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var MM_wrk_editor = require("../worker/MM_wrk_editor.bs.js");
var Expln_React_Row = require("@expln/utils/src/main/react-mui-components/Expln_React_Row.bs.js");
var Expln_React_common = require("@expln/utils/src/main/Expln_React_common.bs.js");
var JsxPPXReactSupport = require("rescript/lib/js/jsxPPXReactSupport.js");
var Select = require("@mui/material/Select").default;
var MenuItem = require("@mui/material/MenuItem").default;
var AutocompleteVirtualized = require("../ui-utils/AutocompleteVirtualized.bs.js");
var IconButton = require("@mui/material/IconButton").default;
var InputLabel = require("@mui/material/InputLabel").default;
var FormControl = require("@mui/material/FormControl").default;
var Delete = require("@mui/icons-material/Delete").default;
var Expln_React_TextFileReader = require("@expln/utils/src/main/react-components/Expln_React_TextFileReader.bs.js");

function MM_cmp_context_selector_single(props) {
  var onDelete = props.onDelete;
  var renderDeleteButton = props.renderDeleteButton;
  var allLabels = props.allLabels;
  var onLabelChange = props.onLabelChange;
  var label = props.label;
  var onReadInstrChange = props.onReadInstrChange;
  var readInstr = props.readInstr;
  var parseError = props.parseError;
  var onFileChange = props.onFileChange;
  var fileSrc = props.fileSrc;
  var onSrcTypeChange = props.onSrcTypeChange;
  var srcType = props.srcType;
  var onUrlBecomesTrusted = props.onUrlBecomesTrusted;
  var trustedUrls = props.trustedUrls;
  var availableWebSrcs = props.availableWebSrcs;
  var modalRef = props.modalRef;
  var actAliasSelected = function (alias) {
    var webSrc = availableWebSrcs.find(function (src) {
          return src.alias === alias;
        });
    if (webSrc !== undefined) {
      return FileLoader.loadFileWithProgress(modalRef, !trustedUrls.includes(webSrc.url), onUrlBecomesTrusted, webSrc.url, "Downloading MM file from \"" + alias + "\"", (function (text) {
                    Curry._2(onFileChange, {
                          TAG: /* Web */1,
                          _0: webSrc
                        }, text);
                  }), undefined, (function (msg) {
                    return "An error occurred while downloading from \"" + alias + "\":" + (" " + Belt_Option.getWithDefault(msg, "") + ".");
                  }), undefined, undefined);
    }
    throw {
          RE_EXN_ID: MM_parser.MmException,
          _1: {
            msg: "Cannot determine a URL for \"" + alias + "\" alias."
          },
          Error: new Error()
        };
  };
  var rndDeleteButton = function (param) {
    if (renderDeleteButton) {
      return React.createElement(IconButton, {
                  onClick: (function (param) {
                      Curry._1(onDelete, undefined);
                    }),
                  children: Caml_option.some(React.createElement(Delete, {}))
                });
    } else {
      return null;
    }
  };
  var rndSourceTypeSelector = function (param) {
    if (Belt_Option.isNone(fileSrc)) {
      return React.createElement(FormControl, {
                  size: "small",
                  children: Caml_option.some(null)
                }, React.createElement(InputLabel, {
                      id: "src-type-select-label",
                      children: "Source type"
                    }), React.createElement(Select, {
                      sx: {
                        width: 130
                      },
                      labelId: "src-type-select-label",
                      label: "Source type",
                      value: MM_wrk_editor.mmFileSourceTypeToStr(srcType),
                      onChange: (function (param) {
                          return Expln_React_common.evt2str((function (str) {
                                        Curry._1(onSrcTypeChange, MM_wrk_editor.mmFileSourceTypeFromStr(str));
                                      }), param);
                        }),
                      children: Caml_option.some(null)
                    }, React.createElement(MenuItem, {
                          value: "Local",
                          children: "Local"
                        }), React.createElement(MenuItem, {
                          value: "Web",
                          children: "Web"
                        })));
    } else {
      return React.createElement("span", undefined, MM_wrk_editor.mmFileSourceTypeToStr(srcType));
    }
  };
  var rndReadInstrTypeSelector = function (param) {
    return React.createElement(FormControl, {
                size: "small",
                children: Caml_option.some(null)
              }, React.createElement(InputLabel, {
                    id: "scope-type-select-label",
                    children: "Scope"
                  }), React.createElement(Select, {
                    labelId: "scope-type-select-label",
                    label: "Scope",
                    value: MM_wrk_editor.readInstrToStr(readInstr),
                    onChange: (function (param) {
                        return Expln_React_common.evt2str((function (str) {
                                      Curry._1(onReadInstrChange, MM_wrk_editor.readInstrFromStr(str));
                                    }), param);
                      }),
                    children: Caml_option.some(null)
                  }, React.createElement(MenuItem, {
                        value: "ReadAll",
                        children: "Read all"
                      }), React.createElement(MenuItem, {
                        value: "StopBefore",
                        children: "Stop before"
                      }), React.createElement(MenuItem, {
                        value: "StopAfter",
                        children: "Stop after"
                      })));
  };
  var rndLabelSelector = function (param) {
    return React.createElement(AutocompleteVirtualized.make, {
                value: label,
                options: allLabels,
                onChange: onLabelChange,
                size: "small"
              });
  };
  var getFileNameFromFileSrc = function (fileSrc) {
    if (fileSrc !== undefined && fileSrc.TAG === /* Local */0) {
      return fileSrc.fileName;
    }
    
  };
  var getAliasFromFileSrc = function (fileSrc) {
    if (fileSrc !== undefined && fileSrc.TAG !== /* Local */0) {
      return fileSrc._0.alias;
    }
    
  };
  var rndSourceSelector = function (param) {
    if (srcType) {
      var alias = getAliasFromFileSrc(fileSrc);
      if (Belt_Option.isNone(alias)) {
        return React.createElement(FormControl, {
                    size: "small",
                    children: Caml_option.some(null)
                  }, React.createElement(InputLabel, {
                        id: "alias-select-label",
                        children: "Alias"
                      }), React.createElement(Select, {
                        sx: {
                          width: 200
                        },
                        labelId: "alias-select-label",
                        label: "Alias",
                        value: Belt_Option.getWithDefault(alias, ""),
                        onChange: (function (param) {
                            return Expln_React_common.evt2str(actAliasSelected, param);
                          }),
                        children: Caml_option.some(availableWebSrcs.map(function (webSrc, i) {
                                  return JsxPPXReactSupport.createElementWithKey(String(i), MenuItem, {
                                              value: webSrc.alias,
                                              children: Caml_option.some(webSrc.alias)
                                            });
                                }))
                      }));
      } else {
        return React.createElement("span", undefined, Belt_Option.getWithDefault(alias, "<web-src-alias>"));
      }
    } else {
      var fileName = getFileNameFromFileSrc(fileSrc);
      if (Belt_Option.isNone(fileName)) {
        return React.createElement(Expln_React_TextFileReader.make, {
                    onChange: (function (selected) {
                        if (selected !== undefined) {
                          return Curry._2(onFileChange, {
                                      TAG: /* Local */0,
                                      fileName: selected[0]
                                    }, selected[1]);
                        }
                        
                      })
                  });
      } else {
        return React.createElement("span", undefined, Belt_Option.getWithDefault(fileName, "<fileName>"));
      }
    }
  };
  var rndReadInstr = function (param) {
    if (parseError !== undefined) {
      return React.createElement("pre", {
                  style: {
                    color: "red"
                  }
                }, "Error: " + parseError);
    } else if (fileSrc !== undefined) {
      return React.createElement(Expln_React_Row.make, {
                  children: Caml_option.some(null)
                }, rndReadInstrTypeSelector(undefined), readInstr !== 0 ? rndLabelSelector(undefined) : null);
    } else {
      return null;
    }
  };
  return React.createElement(Expln_React_Row.make, {
              alignItems: "center",
              spacing: 1,
              children: Caml_option.some(null)
            }, rndDeleteButton(undefined), rndSourceTypeSelector(undefined), rndSourceSelector(undefined), rndReadInstr(undefined));
}

var make = MM_cmp_context_selector_single;

exports.make = make;
/* react Not a pure module */
